const useAllWineUrl = () => {
  const createAllWineUrl = (languageCode: string) => {
    const domain = getWineDomain(languageCode);

    return `/${domain}`;
  };

  const getWineDomain = (languageCode: string): string => {
    switch (languageCode) {
      case 'en':
        return 'wines';
      case 'de':
        return 'weine';
      case 'pl':
        return 'wina';
      case 'hu':
      default:
        return 'borok';
    }
  };

  return { createAllWineUrl };
};

export default useAllWineUrl;
